import { Component } from '@angular/core';
import { ConfiguratorTaskService, EngineEtlService, SelectItem, TaskDTO } from '@tj/tj-dmp-lib-api';
import { BehaviorSubject } from 'rxjs';
import { UtilsService } from '../../services/utils.service';

@Component({
    selector: 'dmp-task',
    templateUrl: './task.component.html',
    styleUrls: ['./task.component.scss'],
    standalone: false
})
export class TaskComponent {
    /** Position de la fenêtre des tâches */
    position = 'bottom';
    displayDialogTasks = false;
    lastRefresh: Date;

    tasks: TaskDTO[] = [];

    private timer;
    private datastore: string;

    displayTasks: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(
        private configuratorTaskService: ConfiguratorTaskService,
        private engineEtlService: EngineEtlService,
        private readonly utilsService: UtilsService
    ) {
    }

    toggleDisplayTasks(){
      this.displayTasks.next(!this.displayTasks.value);
      return this.displayTasks.value;
    }
  
    open():void{
      if(this.displayTasks.value === false){
        this.toggleDisplayTasks();
      }
    }

    ngOnDestroy(): void {
        clearInterval(this.timer);
    }

    ngOnInit() {
        this.displayTasks.subscribe((value) => {
            this.displayDialogTasks = value;
            this.timer = this.refresh();
        });

        this.autoRefresh();
    }

    close() {
        this.displayTasks.next(false);
    }

    autoRefresh() {
        this.timer = setInterval(this.refresh.bind(this), 30 * 1000);
    }

    toggle(){
      this.toggleDisplayTasks();
  }

    refresh() {
        if (!this.displayDialogTasks || !this.datastore) {
            return;
        }
        this.configuratorTaskService.getAllTasksUsingGET(this.datastore).subscribe((res) => {
            this.tasks = res.map(task => ({
                ...task,
                dateCreation: this.utilsService.normalizeTimestampToDate(task.dateCreation),
                dateFin: this.utilsService.normalizeTimestampToDate(task.dateFin),
                dateExec: this.utilsService.normalizeTimestampToDate(task.dateExec)
            }));
            this.tasks = this.tasks.sort((a: TaskDTO, b: TaskDTO) => {
                return new Date(b.dateCreation).getTime() - new Date(a.dateCreation).getTime();
            });
            this.lastRefresh = new Date();
        });
    }

    deleteTask(idTask: any): void {
        this.engineEtlService.deleteThreadForTaskUsingDELETE(idTask)
            .subscribe(() => this.refresh());
    }

    onChangeDataStore(datastore: SelectItem) {
        this.datastore = datastore.value;
        this.refresh();
    }
}
